<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>流水类型</span>
           <el-select 
              v-model="queryInfo.type"
              size="small"
              class="w200Select" 
              @change="typeChange"
            >  
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
        </div>
        <div class="searchItem">
          <span>学员账号</span>
          <el-input
            v-model="queryInfo.username"
            clearable
            size="small"
            placeholder="请输入学员账号"
          ></el-input>
        </div>
        <div class="searchItem">
          <span>订单号</span>
          <el-input
            v-model="queryInfo.order_id"
            clearable
            size="small"
            placeholder="请输入学员账号"
          ></el-input>
        </div> 
        <div class="searchItem">
          <span>时间</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            @change="selectData"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div> 
        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable('search')"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton> 
      </div> 
      <div class="table">
        <el-table 
          :data="tableList"
          style="width: 100%"
          v-loading="loading"
          border  
        >   
          <el-table-column prop="id" label="流水ID" align="center" />
          <el-table-column
            prop="tob_users_id"
            label="开通人（机构登录帐号）"
            align="center"
          />
          <el-table-column prop="created_at" label="创建时间" align="center" />
          <el-table-column prop="type" label="流水类型" align="center">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.type_name"
                :type="scope.row.type == 1 ? 'success' : 'danger'"
              >
                {{ scope.row.type_name }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="transaction" label="交易类型" align="center">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.transaction_name"
                :type="scope.row.transaction == 1 ? 'success' : 'danger'"
              >
                {{  scope.row.transaction_name }}
              </el-tag> 
            </template>
          </el-table-column> 
          <el-table-column prop="order_no" label="订单号" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.qorder">
                {{ scope.row.qorder.order_no }}
              </div>
              <div v-else>{{ scope.row.order_no }}</div>
            </template>
          </el-table-column>   
          <el-table-column prop="username" label="学员账号" align="center">
            <template slot-scope="scope"> 
              <div v-if="scope.row.userext && scope.row.userext.username">
                {{ scope.row.userext.username }}
              </div>
            </template>
          </el-table-column>  
          <el-table-column v-if="queryInfo.type == 1" prop="custom_data_type_name" label="定制资料类型" align="center">
            <template slot-scope="scope"> 
              <div v-if="scope.row.custom_data_type_name">{{ scope.row.custom_data_type_name }}</div> 
            </template>
          </el-table-column> 
          <el-table-column prop="fee" label="金额" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.fee }}{{scope.row.give_fee_text}} 
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div style="text-align: right;padding: 10px 20px;">
        总流水共计{{ queryInfo.total }}条，总金额<span style="color:red">{{ total_fee }}</span>元
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>
      
  </div>
</template>

<script>  
import commonApi from "@/api/common"; 
import MyButton from "@/components/MyButton.vue";
export default {
  name: "CustomOrderFlowing", //交易流水 
  components: { 
    MyButton,
  },
  data() {
    return { 
      queryInfo: {
        type: 1,
        limit: 10,
        page: 1,
        total: 0,
      },  
      tableList: [],
      typeOptions: [
        {
          value: 1, label: '支出'
        },
        {
          value: 2, label: '收入'
        },
      ], 
      timeFrame: [], 
      transactionTypeOptions: [
        { value: 1, label: "视频课程" },
        { value: 2, label: "题库会员" },
        { value: 3, label: "学籍卡" },
        { value: 4, label: "vip学员" },
        { value: 5, label: "退款" },
        { value: 6, label: "充值" },
        { value: 7, label: "平台号码导入" },
        { value: 8, label: "平台导入号码通话" },
        { value: 9, label: "自有号码通话" },
        { value: 10, label: "套餐" },
        { value: 11, label: "学籍卡（卡密）" },
        { value: 12, label: "赠送金额到期" },
        { value: 13, label: "充值扣除" }
      ],
      total_fee: 0,
      loading: false
    };
  },
  computed: {  
  },
  watch: {
    timeFrame: {
      handler(_newVal) {
        if (!_newVal) {
          this.timeFrame = [];
        }
      },
      deep: true,
    },  
  },
  created() {   
    this.queryTable(); 
  },
  methods: { 
    typeChange(){ 
      this.queryTable(); 
    },
    selectData(e) {
      if (e) { 
        this.queryInfo.created_start_time = e[0];
        this.queryInfo.created_end_time = e[1]; 
      } else {
        this.queryInfo.created_start_time = "";
        this.queryInfo.created_end_time = ""; 
      }
    },
    // 列表数据
    async queryTable(_type) {
      if (_type) {
        this.queryInfo.page = 1;
      } 
      this.loading = true
      await commonApi.getCustomOrderFlowing(this.queryInfo).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.queryInfo.total = res.data.total;
          this.tableList = res.data.data;  

          this.total_fee = res.data.total_fee
          this.$forceUpdate() 
        } else {
          this.$message.error(res.message);
        }
      }); 
    },  
    // 分页
    handleSizeChange(e) { 
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    // 重置
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = { 
        type: 1,
        limit: 10,
        page: 1,
        total: 0,
      }; 
      this.queryTable();
    }, 
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin-right: 30px;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 250px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0 20px 0;
    .el-button {
      margin-bottom: 5px;
    }
  }

  // 表格数据
  .table {
    //min-height: calc(100vh - 330px);
  }
  // .operationItem {
  //   display: inline-block;
  //   margin: 0 5px;
  //   cursor: pointer;
  //   color: #00c793;
  // }
  // .operationItem:hover {
  //   color: red;
  // }
  // .operationItemNew {
  //   display: inline-block;
  //   margin: 0 5px;
  //   cursor: pointer;
  //   color: #846ffd;
  //   border: 1px solid #846ffd;
  //   border-radius: 4px;
  //   font-size: 13px;
  //   padding: 0 10px;
  // }
  // .operationItemNew:hover {
  //   color: red;
  //   border: 1px solid red;
  // }

  // 分页
  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;

    .el-pagination{
     display: flex;
     flex-wrap: wrap;
    }
  }

  /deep/ .formDialog {
    .courseDetail {
      img {
        width: 200px;
      }
      p {
        margin-bottom: 10px;
      }
      .couseUl {
        text-decoration: none;
        height: 400px;
        overflow: auto;
        margin-top: 20px;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .sellPriceType {
          background-color: rgb(89, 89, 246);
          color: #fff;
          margin: 0 25px;
          border-radius: 10px;
        }
      }
    }
    .userInfoFormStyle {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      .t1 {
        padding: 0 12px 0 0;
        width: 100px;
        box-sizing: border-box;
        text-align: right;
      }
      .t2 {
      }
      .t3 {
      }
    }
    .userInfoFormStyle-price {
      display: flex;
      line-height: 40px;
      margin-bottom: 15px;
      justify-content: start;
      padding: 0 20px;
      .userInfoFormStyle-price-item {
        width: 50%;
      }
    }
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
    .roleStyle {
      .el-form-item__content {
        display: flex;
        align-items: center;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          cursor: pointer;
        }
        .el-button {
          border: none;
          padding-left: 5px;
        }
        .el-button:focus,
        .el-button:hover {
          background-color: #fff;
        }
      }
    }
  }
}

.teach-extend-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .teach-extend-box-tc {
    color: #d9001b;
  }
}
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
/deep/.tob_good_status_box .el-button--success{
    background: linear-gradient(234deg, #9583ff 0%, #7057ff 100%);
    border-color: #9583ff;
    opacity: 1;
    padding: 5px 10px;
    font-size: 12px;
}
/deep/.tob_good_status_box .el-button--success:hover{
    color: #846ffd; 
    border: 1px solid #846ffd;
    background: #fff;
}
/deep/.tob_good_status_box .el-button{
  color: #fff;
}
/deep/.tob_good_status_box .el-button--info{
  color: #FFF;
  background-color: #909399;
  border-color: #909399;
  opacity: 1;
  padding: 5px 10px;
  font-size: 12px;
}

/deep/.kyye{
    border: 1px solid #00C793;
    border-radius: 3px;
    color: #00C793;
    padding: 0 20px;
    font-size: 14px;
    margin: 0;
    line-height: 40px;
    margin-left: 20px;
}


/* 针对小屏幕设备（例如手机） */
@media (max-width: 600px) {
  .basicStyle{
    padding: 0;
  }
  
 /deep/.el-pagination{
     display: flex;
     flex-wrap: wrap;
  } 
}  
</style>
